// removed by extract-text-webpack-plugin
module.exports = {"icon":"FileLink__icon__3QP7G","preview":"FileLink__preview__3la3V","text":"FileLink__text__1OZui"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FileLink/FileLink.css
// module id = 1254
// module chunks = 0